import { useEffect } from 'react'

import { SubmitHandler, UseFormProps, UseFormReturn } from 'react-hook-form'

import { useFormWithSchema } from '@fortem-monorepo/react-spa'
import { Form } from '@fortem-monorepo/react-ui'

import { useDeleteProviderTaskDataMutation } from '@/react-query/mutations/feeds'

import { type SchemaType, schema } from './DeleteProviderTaskDataForm.schema'

export interface DeleteProviderTaskDataFormProps extends Omit<
  UseFormProps<SchemaType>,
  'resolver'
> {
  children?: ((form: UseFormReturn<SchemaType>) => React.ReactNode) | React.ReactNode
  onSubmit?: SubmitHandler<SchemaType>
}

export const DeleteProviderTaskDataForm: React.FC<DeleteProviderTaskDataFormProps> = ({
  children,
  onSubmit,
  ...props
}) => {
  const form = useFormWithSchema({ mode: 'all', ...props }, schema)

  const deleteProviderTaskDataMutation = useDeleteProviderTaskDataMutation()

  const submit = form.handleSubmit(
    onSubmit ??
      (async (_data, _e) => {
        await deleteProviderTaskDataMutation.mutateAsync(_data)
        form.reset()
      }),
  )

  useEffect(() => {
    form.trigger()
  }, [])

  return (
    <Form {...form}>
      <form onSubmit={submit}>{typeof children === 'function' ? children(form) : children}</form>
    </Form>
  )
}
